import { useState } from "react";
import LightGallery from 'lightgallery/react';

import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';

export const Gallery = (props) => {
  const [modalState, setModal] = useState();

  const [folio, setFolio] = useState(0);



  return (
    <div id='portfolio' className='text-center'>

      <div className='container'>
        <div className='section-title'>
          <h2>{props.data ? props.data.title : 'Loading'}</h2>
          <nav id='menu' className=' navbar-default ' style={{ boxShadow: 'none' }}>
            <ul className='nav navbar-nav '>
              <li>
                <a style={{ cursor: 'pointer' }} className={folio === 0 ? 'activeG' : ''} onClick={() => setFolio(0)}>
                  {props.data ? props.data.p1 : 'Loading'}
                </a>
              </li>
              <li >
                <a style={{ cursor: 'pointer' }} className={folio === 1 ? 'activeG' : ''} onClick={() => setFolio(1)}>
                  {props.data ? props.data.p2 : 'Loading'}
                </a>
              </li>
              <li >
                <a style={{ cursor: 'pointer' }} className={folio === 2 ? 'activeG' : ''} onClick={() => setFolio(2)}>
                  {props.data ? props.data.p3 : 'Loading'}
                </a>
              </li></ul></nav>
        </div>
        <div className='row'>
          {folio === 0 && <div className='portfolio-items'>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              {/* <div > */}
              <div className='portfolio-item' onClick={() => setModal('img/portfolio/web/artv-1.jpeg')} data-toggle="modal" data-target="#largeModal">
                <div className='hover-bg' >
                  {' '}
                  {/* <a
                    href='img/portfolio/web/artv-1.jpeg'
                    title='Project Title'
                    data-lightbox='gallery1'
                    //
                  > */}
                  <div className='hover-text'>
                    <h4>Artv</h4>
                  </div>
                  <img
                    src='img/portfolio/web/artv-sm.jpg'
                    className='img-responsive'
                    alt='Project Title'
                  />{' '}
                  {/* </a> */}{' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item' onClick={() => setModal('img/portfolio/web/ban.jpeg')} data-toggle="modal" data-target="#largeModal">
                <div className='hover-bg'>
                  {' '}
                  <div className='hover-text'>
                    <h4>Banmedica</h4>
                  </div>
                  <img
                    src='img/portfolio/web/ban-sm.jpg'
                    className='img-responsive'
                    alt='Banmedica'
                  />
                  {' '}
                  {' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item' onClick={() => setModal('img/portfolio/web/kankana.jpeg')} data-toggle="modal" data-target="#largeModal">
                <div className='hover-bg'>
                  {' '}
                  <div className='hover-text'>
                    <h4>Kankana del Elqui</h4>
                  </div>
                  <img
                    src='img/portfolio/web/kan-sm.jpg'
                    className='img-responsive'
                    alt='Kankana del Elqui'
                  />{' '}
                  {' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item' onClick={() => setModal('img/portfolio/web/viax.jpeg')} data-toggle="modal" data-target="#largeModal">
                <div className='hover-bg'>
                  {' '}
                  <div className='hover-text'>
                    <h4>ViaX</h4>
                  </div>
                  <img
                    src='img/portfolio/web/viax.jpeg'
                    className='img-responsive'
                    alt='Valdivieso'
                  />{' '}
                  {' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item' onClick={() => setModal('img/portfolio/web/ossom.png')} data-toggle="modal" data-target="#largeModal">
                <div className='hover-bg'>
                  {' '}
                  <div className='hover-text'>
                    <h4>Revista Ossom.cl</h4>
                  </div>

                  <img
                    src='img/portfolio/web/ossom.png'
                    className='img-responsive'
                    alt='Viax'
                  />{' '}
                  {' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item' onClick={() => setModal('img/portfolio/web/viax2.jpeg')} data-toggle="modal" data-target="#largeModal">
                <div className='hover-bg'>
                  {' '}
                  <div className='hover-text'>
                    <h4>Viax 2</h4>
                  </div>
                  <img
                    src='img/portfolio/web/viax2-sm.jpg'
                    className='img-responsive'
                    alt='Viax 2'
                  />{' '}
                  {' '}
                </div>
              </div>
            </div>
            {/* <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item'>
                <div className='hover-bg'>
                  {' '}
                  <a
                    href='img/portfolio/07-large.jpg'
                    title='Project Title'
                    data-lightbox-gallery='gallery1'
                  >
                    <div className='hover-text'>
                      <h4>Dolor Sit</h4>
                    </div>
                    <img
                      src='img/portfolio/07-small.jpg'
                      className='img-responsive'
                      alt='Project Title'
                    />{' '}
                  </a>{' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item'>
                <div className='hover-bg'>
                  {' '}
                  <a
                    href='img/portfolio/08-large.jpg'
                    title='Project Title'
                    data-lightbox-gallery='gallery1'
                  >
                    <div className='hover-text'>
                      <h4>Lorem Ipsum</h4>
                    </div>
                    <img
                      src='img/portfolio/08-small.jpg'
                      className='img-responsive'
                      alt='Project Title'
                    />{' '}
                  </a>{' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item'>
                <div className='hover-bg'>
                  {' '}
                  <a
                    href='img/portfolio/09-large.jpg'
                    title='Project Title'
                    data-lightbox-gallery='gallery1'
                  >
                    <div className='hover-text'>
                      <h4>Adipiscing Elit</h4>
                    </div>
                    <img
                      src='img/portfolio/09-small.jpg'
                      className='img-responsive'
                      alt='Project Title'
                    />{' '}
                  </a>{' '}
                </div>
              </div>
            </div> */}
          </div>}
          {folio === 1 && <div className='portfolio-items'>

            <div className='col-sm-6 col-md-4 col-lg-4' >
              <div className='portfolio-item1' >

                <LightGallery speed={500} plugins={[lgThumbnail]}>

                  <a href="img/portfolio/foto/f7.png"  >
                    <div className='hover-bg' >
                      <div className='hover-text'>
                        <h4>Eventos</h4>
                      </div>
                      <img
                        src='img/portfolio/foto/f7.png'
                        className='img-responsive'
                        alt='Concerts'
                      />
                    </div>
                  </a>


                  <a href="img/portfolio/foto/f8.png" className="hide">
                    <img
                      src='img/portfolio/foto/f8.png'
                      className='img-responsive'
                      alt='Concerts'
                    />
                  </a>
                  <a href="img/portfolio/foto/f5.png" className="hide">
                    <img
                      src='img/portfolio/foto/f5.png'
                      className='img-responsive'
                      alt='Theatre'
                    />
                  </a>
                  <a href="img/portfolio/foto/f9.png" className="hide">
                    <img
                      src='img/portfolio/foto/f9.png'
                      className='img-responsive'
                      alt='Concerts'
                    />
                  </a>
                  <a href="img/portfolio/foto/f10.png" className="hide">
                    <img
                      src='img/portfolio/foto/f10.png'
                      className='img-responsive'
                      alt='Concerts'
                    />
                  </a>
                  <a href="img/portfolio/foto/f6.png" className="hide">
                    <img
                      src='img/portfolio/foto/f6.png'
                      className='img-responsive'
                      alt='Theatre'
                    />
                  </a>
                  


                </LightGallery>
              </div>
            </div>
            
            {/* Publicitaria */}
            <div className='col-sm-6 col-md-4 col-lg-4' >
              <div className='portfolio-item1' >

                <LightGallery speed={500} plugins={[lgThumbnail]}>

                  <a href="img/portfolio/foto/f14.png"  >
                    <div className='hover-bg' >
                      <div className='hover-text'>
                        <h4>Publicitaria</h4>
                      </div>
                      <img
                        src='img/portfolio/foto/f14.png'
                        className='img-responsive'
                        alt='Product Photography'
                        style={{marginTop:"-100px"}}
                      />
                    </div>
                  </a>


                  <a href="img/portfolio/foto/f13.png" className="hide">
                    <img
                      src='img/portfolio/foto/f13.png'
                      className='img-responsive'
                      alt='Food Photography'
                    />
                  </a>
                  <a href="img/portfolio/foto/f11.png" className="hide">
                    <img
                      src='img/portfolio/foto/f11.png'
                      className='img-responsive'
                      alt='Food Photography'
                    />
                  </a>

                </LightGallery>
              </div>
            </div>

            {/* Matrimonios */}

            <div className='col-sm-6 col-md-4 col-lg-4' >
              <div className='portfolio-item1' >

                <LightGallery speed={500} plugins={[lgThumbnail]}>

                  <a href="img/portfolio/foto/f3.png" >
                    <div className='hover-bg' >
                      <div className='hover-text'>
                        <h4>Matrimonios</h4>
                      </div>
                      <img
                        src='img/portfolio/foto/f3.png'
                        className='img-responsive '
                        alt='Fotografía Matrimonios'
                        style={{marginTop:"-130px"}}
                      />
                    </div>
                  </a>


                  <a href="img/portfolio/foto/f2.png" className="hide">
                    <img
                      src='img/portfolio/foto/f2.png'
                      className='img-responsive'
                      alt='Fotografía Matrimonios'
                    />
                  </a>
                  <a href="img/portfolio/foto/f4.png" className="hide">
                    <img
                      src='img/portfolio/foto/f4.png'
                      className='img-responsive'
                      alt='Fotografía Matrimonios'
                    />
                  </a>

                </LightGallery>
              </div>
            </div>


            {/* Arquitectura */}

            <div className='col-sm-6 col-md-4 col-lg-4' >
              <div className='portfolio-item1' >

                <LightGallery speed={500} plugins={[lgThumbnail]}>

                  <a href="img/portfolio/foto/a1.png"  >
                    <div className='hover-bg' >
                      <div className='hover-text'>
                        <h4>Arquitectura</h4>
                      </div>
                      <img
                        src='img/portfolio/foto/a1.png'
                        className='img-responsive'
                        alt='Fotografía Arquitectura '
                      />
                    </div>
                  </a>


                  <a href="img/portfolio/foto/a2.png" className="hide">
                    <img
                      src='img/portfolio/foto/a2.png'
                      className='img-responsive'
                      alt='Fotografía Arquitectura '
                    />
                  </a>
                  <a href="img/portfolio/foto/a3.png" className="hide">
                    <img
                      src='img/portfolio/foto/a3.png'
                      className='img-responsive'
                      alt='Fotografía Arquitectura '
                    />
                  </a>

                </LightGallery>
              </div>
            </div>

             {/* PortFolio */}

             <div className='col-sm-6 col-md-4 col-lg-4' >
              <div className='portfolio-item1' >

                <LightGallery speed={500} plugins={[lgThumbnail]}>

                  <a href="img/portfolio/foto/p3.png"  >
                    <div className='hover-bg' >
                      <div className='hover-text'>
                        <h4>PortFolio</h4>
                      </div>
                      <img
                        src='img/portfolio/foto/p3.png'
                        className='img-responsive'
                        alt='Fotografía PortFolio'
                      />
                    </div>
                  </a>


                  <a href="img/portfolio/foto/p2.png" className="hide">
                    <img
                      src='img/portfolio/foto/p2.png'
                      className='img-responsive'
                      alt='Fotografía PortFolio'
                    />
                  </a>
                  <a href="img/portfolio/foto/p1.png" className="hide">
                    <img
                      src='img/portfolio/foto/p1.png'
                      className='img-responsive'
                      alt='Fotografía PortFolio'
                    />
                  </a>
                  <a href="img/portfolio/foto/p5.png" className="hide">
                    <img
                      src='img/portfolio/foto/p5.png'
                      className='img-responsive'
                      alt='Fotografía PortFolio'
                    />
                  </a>
                  <a href="img/portfolio/foto/p4.png" className="hide">
                    <img
                      src='img/portfolio/foto/p4.png'
                      className='img-responsive'
                      alt='Fotografía PortFolio'
                    />
                  </a>

                </LightGallery>
              </div>
            </div>


              {/* Empresarial */}

              <div className='col-sm-6 col-md-4 col-lg-4' >
              <div className='portfolio-item1' >

                <LightGallery speed={500} plugins={[lgThumbnail]}>

                  <a href="img/portfolio/foto/e1.png"  >
                    <div className='hover-bg' >
                      <div className='hover-text'>
                        <h4>Empresarial</h4>
                      </div>
                      <img
                        src='img/portfolio/foto/e1.png'
                        className='img-responsive'
                        alt='Fotografía Empresarial'
                      />
                    </div>
                  </a>


                  <a href="img/portfolio/foto/e2.png" className="hide">
                    <img
                      src='img/portfolio/foto/e2.png'
                      className='img-responsive'
                      alt='Fotografía Empresarial'
                    />
                  </a>
                  <a href="img/portfolio/foto/e3.png" className="hide">
                    <img
                      src='img/portfolio/foto/e3.png'
                      className='img-responsive'
                      alt='Fotografía Empresarial'
                    />
                  </a>

                </LightGallery>
              </div>
            </div>













          </div>}

          {folio === 2 && <div className='portfolio-items'>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              {/* <div > */}
              <div className='portfolio-item' onClick={() => setModal('img/portfolio/rss/r4.png')} data-toggle="modal" data-target="#smallModal">
                <div className='hover-bg' >
                  {' '}
                  {/* <a
                    href='img/portfolio/web/artv-1.jpeg'
                    title='Project Title'
                    data-lightbox='gallery1'
                    //
                  > */}
                  {/* <div className='hover-text'>
                      <h4>Artv1</h4>
                    </div> */}
                  <img
                    src='img/portfolio/rss/r4.png'
                    className='img-responsive'
                    alt='Project Title'
                  />{' '}
                  {/* </a> */}{' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item' onClick={() => setModal('img/portfolio/rss/r1.png')} data-toggle="modal" data-target="#smallModal">
                <div className='hover-bg'>
                  {' '}
                  {/* <div className='hover-text'>
                      <h4>Banmedica</h4>
                    </div> */}
                  <img
                    src='img/portfolio/rss/r1.png'
                    className='img-responsive'
                    alt='Banmedica'
                  />

                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item' onClick={() => setModal('img/portfolio/rss/r2.png')} data-toggle="modal" data-target="#smallModal">
                <div className='hover-bg'>

                  {/* <div className='hover-text'>
                      <h4>Kankana del Elqui</h4>
                    </div> */}
                  <img
                    src='img/portfolio/rss/r2.png'
                    className='img-responsive'
                    alt='Kankana del Elqui'
                  />{' '}
                  {' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item' onClick={() => setModal('img/portfolio/rss/r6.png')} data-toggle="modal" data-target="#smallModal">
                <div className='hover-bg'>
                  {/* <div className='hover-text'>
                      <h4>ViaX</h4>
                    </div> */}
                  <img
                    src='img/portfolio/rss/r6.png'
                    className='img-responsive'
                    alt='Valdivieso'
                  />{' '}
                  {' '}
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item' onClick={() => setModal('img/portfolio/rss/r3.png')} data-toggle="modal" data-target="#smallModal">
                <div className='hover-bg'>

                  {/* <div className='hover-text'>
                      <h4>Cushman & Wakefield</h4>
                    </div> */}

                  <img
                    src='img/portfolio/rss/r3.png'
                    className='img-responsive'
                    alt='Viax'
                  />
                </div>
              </div>
            </div>
            <div className='col-sm-6 col-md-4 col-lg-4'>
              <div className='portfolio-item' onClick={() => setModal('img/portfolio/rss/r7.png')} data-toggle="modal" data-target="#smallModal">
                <div className='hover-bg'>

                  {/* <div className='hover-text'>
                      <h4>Viax 2</h4>
                    </div> */}
                  <img
                    src='img/portfolio/rss/r7.png'
                    className='img-responsive'
                    alt='Viax 2'
                  />{' '}
                  {' '}
                </div>
              </div>
            </div>

          </div>}
        </div>
      </div>



      <div class="modal fade" id="largeModal" tabindex="-1" role="dialog" aria-labelledby="largeModal" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            {modalState?.split('.').pop() === 'mp4' ? <video width="100%" controls>
              <source src={modalState} type="video/mp4" /></video> :
              <img src={modalState} width="100%" />}
          </div>
        </div>
      </div>

      <div class="modal fade" id="smallModal" tabindex="-1" role="dialog" aria-labelledby="smallModal" aria-hidden="true">
        <div class="modal-dialog modal-md">
          <div class="modal-content">
            {modalState?.split('.').pop() === 'mp4' ? <video width="100%" controls>
              <source src={modalState} type="video/mp4" /></video> :
              <img src={modalState} width="100%" />}
          </div>
        </div>
      </div>



    </div>


  )
}
